import styles from "./styles/media-formats-input-player.module.scss";
import Image from "next/image";
import defaultIcon from "@/assets/icons/default-media-icon.webp";
import WavePlayerProgress from "@/components/common/music-player/wave-player-progress";
import React from "react";
import { useWaveSurfer } from "@/hooks/music-players/use-wave-surfer";
import playIcon from "@/assets/music-player/play-secondary.svg";
import pauseIcon from "@/assets/music-player/stop-secondary.svg";

interface MediaFormatsInputProps {
  url: string;
  fileName: string;
  image?: string;
}

const MediaFormatsInputPlayer = ({
  url,
  fileName,
  image,
}: MediaFormatsInputProps) => {
  const waveSurfer = useWaveSurfer(url);

  const icon = waveSurfer.isPlaying ? pauseIcon : playIcon;

  return (
    <div className={styles.musicplayer_wrapper}>
      <div className={styles.icon_wrapper}>
        <Image
          className={styles.icon}
          src={image ?? defaultIcon}
          alt="music-icon"
          sizes="auto"
          fill
        />
      </div>
      <div className={styles.title}>{fileName}</div>
      <WavePlayerProgress displayTime={true} {...waveSurfer} />
      <Image
        alt={waveSurfer.isPlaying ? "pause" : "play"}
        onClick={waveSurfer.togglePlay}
        src={icon}
        height={40}
        width={40}
        style={{ cursor: "pointer" }}
      />
    </div>
  );
};

export default MediaFormatsInputPlayer;
